import React from 'react';
import {
    Cell,
    Grid,
    H2,
} from '@saladbob/sassafras';

import style from './bracket.module.css';

import Game from './Game';
import ByGame from './ByGame';

import { Game as GameType } from '../../types'

type Props = {
    games: GameType[],
    tbGames: GameType[],
};

const rows = 59;

const Bracket17: React.FC<Props> = ({games, tbGames}) => {
    return (
        <div style={{ height: '100%' }}>
            <Grid columns="repeat(9, max-content)">
                {/* Round 1 */}
                <Grid rows={`repeat(${rows}, 1fr)`}>
                    <Cell style={{ gridRow: '20 / 22' }}>
                        <Game game={games[0]} topLabel bottomLabel />
                    </Cell>

                    {/* Losers */}

                    <Cell style={{ gridRow: '38 / 39' }} ps="md">
                        <H2 font="leader" className={style.bracketHeading} color="primary">LOSERS BRACKET</H2>
                    </Cell>

                    <Cell style={{ gridRow: '40 / 42' }}>
                        <Game game={games[9]} topLabel bottomLabel/>
                    </Cell>

                </Grid>
                {/* Round 2 */}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`}>
                    <Cell style={{ gridRow: '1 / 3' }}>
                        <Game game={games[1]} topLabel bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '5 / 7' }}>
                        <Game game={games[2]} topLabel bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '9 / 11' }}>
                        <Game game={games[3]} topLabel bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '13 / 15' }}>
                        <Game game={games[4]} topLabel bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '17 / 19' }}>
                        <Game game={games[5]} topLabel bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '21 / 23' }}>
                        <Game game={games[6]} bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '25 / 27' }}>
                        <Game game={games[7]} topLabel bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '29 / 31' }}>
                        <Game game={games[8]} topLabel bottomLabel />
                    </Cell>

                    {/* Toilet Bowl Heading */}

                    <Cell style={{ gridRow: '35 / 37' }} align="center" justify="flex-end" pe="sm">
                        <H2 font="leader" className={style.bracketHeading} color="primary">TOILET BOWL</H2>
                    </Cell>

                    {/* Losers */}

                    <Cell style={{ gridRow: '41 / 43' }}>
                        <Game game={games[17]} bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '45 / 47' }}>
                        <Game game={games[14]} topLabel bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '49 / 51' }}>
                        <Game game={games[15]} topLabel bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '54 / 56' }}>
                        <Game game={games[16]} topLabel bottomLabel />
                    </Cell>
                </Grid>
                {/* Round 3 */}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`}>
                    <Cell style={{ gridRow: '2 / 6' }}>
                        <Game game={games[10]} />
                    </Cell>
                    <Cell style={{ gridRow: '10 / 14' }}>
                        <Game game={games[11]} />
                    </Cell>
                    <Cell style={{ gridRow: '18 / 22' }}>
                        <Game game={games[12]} />
                    </Cell>
                    <Cell style={{ gridRow: '26 / 30' }}>
                        <Game game={games[13]} />
                    </Cell>

                    {/* Toilet Bowl */}

                    <Cell style={{ gridRow: '32 / 35' }} bgColor="tertiary200" />
                    <Cell style={{ gridRow: '35 / 37' }} bgColor="tertiary200" >
                        <Game game={tbGames[0]} bottomLabel topLabel />
                    </Cell>
                    <Cell style={{ gridRow: '37 / 38' }} bgColor="tertiary200" />

                    {/* Losers */}

                    <Cell style={{ gridRow: '42 / 44' }}>
                        <Game game={games[18]} bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '46 / 48' }}>
                        <Game game={games[19]} bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '50 / 52' }}>
                        <Game game={games[20]} bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '55 / 58' }}>
                        <Game game={games[21]} bottomLabel />
                    </Cell>
                </Grid>
                {/* Round 4 */}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`}>
                    <Cell style={{ gridRow: '4 / 12' }}>
                        <Game game={games[22]} />
                    </Cell>
                    <Cell style={{ gridRow: '20 / 28' }}>
                        <Game game={games[23]} />
                    </Cell>

                    {/* Toilet Bowl */}

                    <Cell style={{ gridRow: '32 / 34' }} bgColor="tertiary200">
                        <Game game={tbGames[1]} bottomLabel topLabel />
                    </Cell>
                    <Cell style={{ gridRow: '34 / 36' }} bgColor="tertiary200" />
                    <Cell style={{ gridRow: '36 / 38' }} bgColor="tertiary200">
                        <Game game={tbGames[2]} bottomLabel />
                    </Cell>

                    {/* Losers */}

                    <Cell style={{ gridRow: '43 / 47' }}>
                        <Game game={games[24]}  />
                    </Cell>

                    <Cell style={{ gridRow: '51 / 57' }}>
                        <Game game={games[25]}  />
                    </Cell>
                </Grid>

                {/* Round 5 */}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`}>

                    <Cell style={{ gridRow: '8 / 24' }}>
                        <Game game={games[26]} />
                    </Cell>

                    {/* TB Finals */}

                    <Cell style={{ gridRow: '32 / 33' }} bgColor="tertiary200" />
                    <Cell style={{ gridRow: '33 / 37' }} bgColor="tertiary200">
                        <Game game={tbGames[3]} />
                    </Cell>
                    <Cell style={{ gridRow: '37 / 38' }} bgColor="tertiary200" />
                    {/* Losers */}

                    <Cell style={{ gridRow: '45 / 49' }}>
                        <Game game={games[27]} bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '53 / 59' }}>
                        <Game game={games[28]} bottomLabel />
                    </Cell>
                </Grid>
                {/* Round 6 */}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`}>
                    <Cell style={{ gridRow: '16 / 16' }}>
                        <ByGame />
                    </Cell>

                    {/* TB Winner */}
                    <Cell style={{ gridRow: '32 / 35' }} bgColor="tertiary200" width="100px" />
                    <Cell style={{ gridRow: '35 / 35' }} bgColor="tertiary200" width="100px">
                        <ByGame tb color="black" />
                    </Cell>
                    <Cell style={{ gridRow: '36 / 38' }} bgColor="tertiary200" width="100px"/>

                    {/* Losers */}
                    <Cell style={{ gridRow: '47 / 57' }}>
                        <Game game={games[29]} />
                    </Cell>
                </Grid>
                {/* Round 7 */}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`}>
                    <Cell style={{ gridRow: '16 / 16' }}>
                        <ByGame />
                    </Cell>

                    {/* Losers */}
                    <Cell style={{ gridRow: '51 / 59' }}>
                        <Game game={games[30]}
                            bottomLabel
                            trophy='trophy'
                            trophyColor={['#A05822', 'white']}
                        />
                    </Cell>
                </Grid>
                {/* Round 8 */}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`}>
                    <Cell style={{ gridRow: '16 / 55' }} className={style.lastGame}>
                        <Game game={games[31]} />
                    </Cell>
                </Grid>
                {/* Round 9 */}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`} className={`${style.championship} ${style.printOnly}`}>
                    <Cell style={{ gridRow: '35 / 37' }} width="100px">
                        <ByGame
                            trophy
                            color={['tertiary600', 'tertiary800']}
                            loserTrophy
                            loserColor="neutral"
                        />
                    </Cell>
                    <Cell style={{ gridRow: '37 / 39' }}>
                        <Game game={games[32]} />
                    </Cell>
                </Grid>

                {games[31].winner && games[31].team2.id === games[31].winner.id && (
                    <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`} className={`${style.championship} ${style.screenOnly}`}>
                        <Cell style={{ gridRow: '20 / 51' }} width="260px">
                            <Game game={games[32]} />
                        </Cell>
                    </Grid>
                )}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`} className={`${style.championship} ${style.screenOnly}`}>
                    <Cell style={{ gridRow: '35 / 37' }} width="100px">
                        <ByGame
                            trophy
                            loserTrophy
                        />
                    </Cell>
                </Grid>
            </Grid>
        </div>
    );
}

export default Bracket17;
